export default function ErrorBox({ message }: { message: string }) {
    const error = btoa(message).replace(/=/g, '');
    return (
        <div className="text-gray-300 px-4 py-3 flex-col flex text-center" role="alert">
            <strong className="font-bold">
                Unexpected Error
            </strong>
            <span className="block sm:inline">{error}</span>
        </div>
    );
}
